import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M3.6 15h10.55","key":"svg-1"}],["path",{"d":"M6.551 4.938l3.26 10.034","key":"svg-2"}],["path",{"d":"M17.032 4.636l-8.535 6.201","key":"svg-3"}],["path",{"d":"M20.559 14.51l-8.535 -6.201","key":"svg-4"}],["path",{"d":"M12.257 20.916l3.261 -10.034","key":"svg-5"}]]

const IconAperture = createReactComponent('outline', 'aperture', 'Aperture', __iconNode);

export default IconAperture;